import { useDispatch, useSelector } from "react-redux";
import { setYardSummaryModalIsOpen } from "../../../store/yardSlice";
import useModalClose from "../../../hooks/useModalClose";
import Close from "../../../assets/icons/closeButton.png";
import "../../../assets/css/YardView/YardSummary.css";

const MODAL_ID = "yard-summary-modal-wrapper-id";

const YardSummary = () => {
  const dispatch = useDispatch();

  const { yardCapacityData } = useSelector((state) => state.yard);

  useModalClose(MODAL_ID, () => dispatch(setYardSummaryModalIsOpen(false)));

  return (
    <div id={MODAL_ID} className="yard-summary-modal-wrapper">
      <div className="yard-summary-modal">
        <div className="yard-summary-modal-top-section">
          <h3>Yard Summary</h3>
          <img
            src={Close}
            onClick={() => dispatch(setYardSummaryModalIsOpen(false))}
            alt="close_icon"
          />
        </div>
        <div className="yard-summary-modal-bottom-section">
          {yardCapacityData ? (
            <div className="yard-bottom-item-container">
              {[
                {
                  label: "Yard Capacity",
                  value: yardCapacityData.yardCapacity
                },
                {
                  label: "Trailers in Yard",
                  value: yardCapacityData.totalTrailers
                },
                {
                  label: "Empty Slots",
                  value: yardCapacityData.emptySlots
                },
                {
                  label: "Utilization",
                  value: `${yardCapacityData.utilizationPercentage}%`
                }
              ].map(({ label, value }) => (
                <div className="yard-summary-shift-box">
                  <div className="yard-summary-shift-box-top-section">
                    <p>{value}</p>
                  </div>
                  <div className="yard-summary-shift-box-bottom-section">
                    <p>{label}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            "Loading Yard Summary..."
          )}
        </div>
      </div>
    </div>
  );
};

export default YardSummary;
